import i18n from '~/common/helpers/i18n';

export const getTranslateMessageArray = (
  errors: { code: string; message: string }[]
): string => {
  const messages = errors
    .map(error => {
      if (error.code === '[previouslyUsed]password') {
        const passwordCount = error?.message?.match(/\d+/)?.[0] || '';
        return i18n.t('scenes.login.messages.error.already_used_password', {
          passwordCount
        });
      }

      if (error.code === '[tooLong]password') {
        const maxLength = error?.message?.match(/\d+/)?.[0] || '';
        return i18n.t('scenes.login.messages.error.password_too_long', {
          maxLength
        });
      }

      return null;
    })
    .filter(Boolean);

  if (messages.length === 0) {
    return i18n.t('common.error.generic_prompt');
  }

  return messages.join(', ');
};
